// @section 1 Command palette - thin wrapper over @navipoint/ui CommandPalette.
// The implementation (fuzzy scoring, localStorage recents, keyboard nav,
// mt-cmdk dark styling) lives in the master component library since
// 2026-06-10; this file only declares the Atlas action set. Props are
// unchanged from the previous local implementation, so App.tsx needs no
// edits. Recents key is preserved; old label-based entries simply age out.

import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { CommandPalette as MtCommandPalette, type CommandAction } from '@navipoint/ui';

// @subsection 1.1 Atlas action registry + wrapper
export function CommandPalette({
  open,
  onClose,
  onCapture,
  onShutdown,
}: {
  open: boolean;
  onClose: () => void;
  onCapture: () => void;
  onShutdown: () => void;
}) {
  const nav = useNavigate();

  const actions = useMemo<CommandAction[]>(
    () => [
      { id: 'go-my-day',   group: 'go',     label: 'My Day',   keywords: ['home', 'today'], onRun: () => nav('/') },
      { id: 'go-crm',      group: 'go',     label: 'CRM',      keywords: ['contacts', 'deals'], onRun: () => nav('/crm') },
      { id: 'go-strategy', group: 'go',     label: 'Strategy', onRun: () => nav('/strategy') },
      { id: 'go-tasks',    group: 'go',     label: 'Tasks',    keywords: ['pm', 'todo'], onRun: () => nav('/pm') },
      { id: 'go-delivery', group: 'go',     label: 'Delivery', onRun: () => nav('/delivery') },
      { id: 'go-erp',      group: 'go',     label: 'ERP',      keywords: ['financials'], onRun: () => nav('/erp') },
      { id: 'capture',     group: 'create', label: 'Capture thought', keywords: ['voice', 'note'], onRun: onCapture },
      { id: 'new-task',    group: 'create', label: 'New task...',     onRun: () => nav('/pm') },
      { id: 'new-contact', group: 'create', label: 'New contact...',  onRun: () => nav('/crm') },
      { id: 'shutdown',    group: 'action', label: 'End of day shutdown', keywords: ['eod'], onRun: onShutdown },
    ],
    [nav, onCapture, onShutdown],
  );

  return (
    <MtCommandPalette
      open={open}
      onClose={onClose}
      actions={actions}
      placeholder="Jump to anything..."
      recentsKey="hq_cmdk_recents"
    />
  );
}
